import React from 'react';
import { bool, func, object, string } from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { ensureOwnListing } from '../../util/data';
import { LISTING_STATE_DRAFT } from '../../util/types';
import { ListingLink } from '..';
import { EditListingAssessmentAccreditationsForm } from '../../forms';

import css from './EditListingAssessmentAccreditationsPanel.module.css';
import { convertKeywordToSearch } from '../../util/search';
import config from '../../config';

const EditListingAssessmentAccreditationsPanel = props => {
  const {
    className,
    rootClassName,
    listing,
    disabled,
    ready,
    onSubmit,
    onChange,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const currentListing = ensureOwnListing(listing);
  const { publicData : { assessmentAccreditations, assessmentAccreditationsOther } } = currentListing?.attributes || {};
  const { filters } = config.custom;

  const isPublished = currentListing.id && currentListing.attributes.state !== LISTING_STATE_DRAFT;
  const panelTitle = isPublished ? (
    <FormattedMessage
      id="EditListingAssessmentAccreditationsPanel.title"
      values={{
        listingTitle: (
          <ListingLink listing={listing}>
            <FormattedMessage id="EditListingAssessmentAccreditationsPanel.listingTitle" />
          </ListingLink>
        ),
      }}
    />
  ) : (
    <FormattedMessage id="EditListingAssessmentAccreditationsPanel.createListingTitle" />
  );

  return (
    <div className={classes}>
      <h1 className={css.title}>{panelTitle}</h1>
      <EditListingAssessmentAccreditationsForm
        className={css.form}
        initialValues={{ assessmentAccreditations, assessmentAccreditationsOther }}
        saveActionMsg={submitButtonText}
        onSubmit={values => {
          const { assessmentAccreditations = [], assessmentAccreditationsOther } = values;
          const updateValues = {
            publicData: {
              assessmentAccreditations,
              assessmentAccreditationsOther,
              assessmentAccreditationsToSearch : convertKeywordToSearch({
                filterId: 'assessmentAccreditations',
                filters,
                keyList: assessmentAccreditations,
                keyOther: assessmentAccreditationsOther
              })
            },
          };

          onSubmit(updateValues);
        }}
        onChange={onChange}
        disabled={disabled}
        ready={ready}
        updated={panelUpdated}
        updateInProgress={updateInProgress}
        fetchErrors={errors}
      />
    </div>
  );
};

EditListingAssessmentAccreditationsPanel.defaultProps = {
  className: null,
  rootClassName: null,
  errors: null,
  listing: null,
};

EditListingAssessmentAccreditationsPanel.propTypes = {
  className: string,
  rootClassName: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

export default EditListingAssessmentAccreditationsPanel;
